export const outlineFocusMixin =
  'focus-visible:!outline !outline-semantic-blue-300 !outline-offset-1 !outline-2'
